var map = {
	"./music-instructions.json": 4586,
	"./music-library-intro2024.json": 4587,
	"./music-library-launch2024.json": 4588,
	"./music-progression.json": 4589,
	"./startSourcesAdvanced.json": 4590,
	"./startSourcesSimple.json": 4591,
	"./startSourcesSimple2.json": 4592,
	"./startSourcesTracks.json": 4593
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 4353;